import * as React from "react";
import { cn } from "../lib";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: "soft" | "outline";
}

const Badge = ({ className, variant = "soft", ...props }: BadgeProps) => {
  return (
    <span
      className={cn(
        "inline-flex h-8 items-center rounded-full px-4 text-sm font-medium",
        variant === "soft" ? "bg-[#F7F8FD] text-[#161827]" : " text-gray-20",
        className,
      )}
      {...props}
    />
  );
};

export { Badge };
